import React, { useMemo } from 'react';
import { number } from '../../../Common/Util/number';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import TableComponent from '../../../Common/Charts/TableCharts';

const titleMap = {
    performed: 'Procedimentos Realizados',
    asked: 'Procedimentos Solicitados',
    'principal-diagnosis': 'Diagnósticos Principais'
};

export const Table = ({ type }) => {
    const { chartData } = useServicesChartsDataContext();

    const dataMap = useMemo(() => {
        return {
            performed: chartData.counterProcedureRea,
            asked: chartData.counterProcedureSolic,
            'principal-diagnosis': chartData.counterDiagPrinc
        };
    }, [chartData]);

    const columns = [
        {
            key: 'cod',
            header: 'Código',
            headerStyle: {
                width: '15%',
                fontWeight: '500'
            }
        },
        {
            key: 'description',
            header: 'Nome',
            headerStyle: {
                width: '60%',
                fontWeight: '500'
            }
        },
        {
            key: 'services',
            header: 'Total de Procedimentos',
            headerStyle: {
                width: '25%',
                textAlign: 'right',
                fontWeight: '500'
            },
            cellStyle: {
                textAlign: 'right'
            },
            formatter: (value) => number.formatToBRNumber(value)
        }
    ];

    return (
        <div className="chart-container-dashboards">
            <TableComponent
                title={titleMap[type] || 'Informações de Procedimentos'}
                data={dataMap[type] || []}
                columns={columns}
                showTotal={true}
                isLastTotal
                maxHeight="500px"
                className="w-100"
                totalColumn="services"
            />
        </div>
    );
};
